import { render, staticRenderFns } from "./notifyObject.vue?vue&type=template&id=00629b48&scoped=true&"
import script from "./notifyObject.vue?vue&type=script&lang=js&"
export * from "./notifyObject.vue?vue&type=script&lang=js&"
import style0 from "./notifyObject.vue?vue&type=style&index=0&id=00629b48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00629b48",
  null
  
)

export default component.exports